export default __webpack_public_path__ + "static/media/0000..0000.f119d1a8.png";